import React from 'react';
import { AppViewRouterProps } from './types';
import { WorkspaceDashboardRouter } from './WorkspaceDashboardRouter';
import { WorkspaceCollaborationRouter } from './WorkspaceCollaborationRouter';

export const GlobalViewsRouter: React.FC<AppViewRouterProps> = (props) => {
  return (
    <>
      <WorkspaceDashboardRouter {...props} />
      <WorkspaceCollaborationRouter {...props} />
    </>
  );
};

export default GlobalViewsRouter;
